export class MedirexPdf {
	public blob: Blob
	public url: string

	constructor(private contents: string, private name: string = `${new Date().toISOString().replace(/[:T\-Z]/g, '')}.pdf`) {
		this.blob = this.base64ToBlob(this.contents)
		this.url = window.URL.createObjectURL(this.blob)
	}

	private base64ToBlob(base64: string): Blob {
		let byteCharacters = atob(this.contents)

		let byteNumbers = new Array(byteCharacters.length)
		for (let i = 0; i < byteCharacters.length; i++) {
			byteNumbers[i] = byteCharacters.charCodeAt(i)
		}
		let byteArray = new Uint8Array(byteNumbers)
		return new Blob([byteArray], { type: this.getFileType(byteArray) })
	}

	public download(): void {
		const link = document.createElement('a')
		link.href = this.url
		link.setAttribute('download', this.name)
		document.body.appendChild(link)
		link.click()
		link.remove()
	}

	public open(): void {
		window.open(this.url, '_blank')
	}

	private getFileType(byteArray: Uint8Array): string {
		const firstByte = byteArray[0]
		const secondByte = byteArray[1]
		const thirdByte = byteArray[2]

		switch (true) {
			case byteArray.length > 4 && firstByte === 0x25 && secondByte === 0x50 && thirdByte === 0x44 && byteArray[3] === 0x46 && byteArray[4] === 0x2d:
				return 'application/pdf'
			case byteArray.length > 8 && firstByte === 0x89 && secondByte === 0x50 && thirdByte === 0x4e && byteArray[3] === 0x47 && byteArray[4] === 0x0d && byteArray[5] === 0x0a && byteArray[6] === 0x1a && byteArray[7] === 0x0a:
				return 'image/png'
			case byteArray.length > 4 && firstByte === 0xff && secondByte === 0xd8 && thirdByte === 0xff && byteArray[3] === 0xe0:
				return 'image/jpeg'
			case byteArray.length > 2 && firstByte === 0x50 && secondByte === 0x4b && thirdByte === 0x03 && byteArray[3] === 0x04:
				return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
			default:
				return 'application/pdf'
		}
	}
}
